import { connectRefinementList } from 'react-instantsearch-dom'
import Phrase from '../../../libs/translationsUtils/phrase'
import { RefinementListProvided } from 'react-instantsearch-core'
import { ComponentChildren } from 'preact'
import { RefinedTypesContent } from './RefinedTypesContent'

type ContentType = 'event' | 'ideation' | 'discussion' | 'question' | 'article' | 'productUpdate'

interface TopicTypesProps extends RefinementListProvided {
  title: ComponentChildren
}

const labelMapping: Record<ContentType, JSX.Element | string> = {
  ideation: <Phrase m='Forum' p='topic.form.type.idea.label' />,
  discussion: <Phrase m='Forum' p='topic.form.type.discussion.label' />,
  article: <Phrase m='Forum' p='advanced.search.filter.article' />,
  question: <Phrase m='Forum' p='topic.form.type.question.label' />,
  productUpdate: <Phrase m='Forum' p='topic.form.type.product.updates.label' />,
  event: 'Event'
}

const extractLabel = (key: string) => {
  if (key in labelMapping) {
    return labelMapping[key as ContentType]
  }
  return key
}

const TopicTypesList = ({ title, ...restProps }: TopicTypesProps) => {
  return (
    <div className='instant-search__topic-type-filter'>
      <span className='instant-search__filter-title'>{title}</span>
      <RefinedTypesContent labelExtractor={extractLabel} {...restProps} />
    </div>
  )
}

export default connectRefinementList(TopicTypesList)
